import React, { useState } from 'react';

const SEGMENTS = ['All Contacts','All Clubs','All Scouts','Activated Clubs','Scouts — No eval yet','Active Scouts'];

const INITIAL_CAMPAIGNS = [
  { id:1, name:'Activation reminder — Scouts', segment:'Scouts — No eval yet', message:'Hi {{first_name}}, you have a player waiting for evaluation on TransferExpo. Submit your eval and earn today → txp.co/eval', sent:94, delivered:91, status:'Sent', date:'Apr 1, 2026' },
  { id:2, name:'Club onboarding nudge',        segment:'All Clubs',            message:'Hey {{first_name}}, your TransferExpo club account is ready. Post your first player request today → txp.co/clubs', sent:312, delivered:298, status:'Sent', date:'Mar 28, 2026' },
  { id:3, name:'May re-engagement',            segment:'Scouts — No eval yet', message:'', sent:0, delivered:0, status:'Draft', date:'—' },
];

const statusBadge = s => ({ Sent:'badge badge-green', Scheduled:'badge badge-blue', Draft:'badge badge-gray' })[s] || 'badge badge-gray';

export default function SMS({ toast }) {
  const [campaigns, setCampaigns] = useState(INITIAL_CAMPAIGNS);
  const [composing, setComposing] = useState(false);
  const [draft, setDraft]         = useState({ name:'', segment:'All Scouts', message:'', scheduleLater:false, scheduleDate:'' });

  const charCount  = draft.message.length;
  const smsCount   = Math.ceil(charCount / 160) || 1;

  const send = () => {
    if (!draft.name||!draft.message) { toast?.('Fill in name and message','warning'); return; }
    const segCounts = { 'All Contacts':5159,'All Clubs':3527,'All Scouts':1632,'Activated Clubs':27,'Scouts — No eval yet':94,'Active Scouts':80 };
    const est = segCounts[draft.segment]||100;
    const c = { id:Date.now(), name:draft.name, segment:draft.segment, message:draft.message, sent:draft.scheduleLater?0:est, delivered:draft.scheduleLater?0:Math.round(est*0.97), status:draft.scheduleLater?'Scheduled':'Sent', date:draft.scheduleLater?draft.scheduleDate:new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) };
    setCampaigns(prev=>[c,...prev]);
    setDraft({ name:'', segment:'All Scouts', message:'', scheduleLater:false, scheduleDate:'' });
    setComposing(false);
    toast?.(draft.scheduleLater?'SMS scheduled!':'SMS campaign sent!');
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Campaigns sent</div><div className="stat-value">{campaigns.filter(c=>c.status==='Sent').length}</div><div className="stat-sub">All time</div></div>
        <div className="stat-card"><div className="stat-label">Total sent</div><div className="stat-value">{campaigns.reduce((s,c)=>s+c.sent,0).toLocaleString()}</div><div className="stat-sub stat-up">Messages</div></div>
        <div className="stat-card"><div className="stat-label">Delivery rate</div><div className="stat-value">{campaigns.filter(c=>c.sent>0).length?Math.round((campaigns.reduce((s,c)=>s+c.delivered,0)/campaigns.reduce((s,c)=>s+c.sent,0))*100)+'%':'—'}</div><div className="stat-sub stat-up">Avg delivery</div></div>
        <div className="stat-card"><div className="stat-label">Drafts</div><div className="stat-value">{campaigns.filter(c=>c.status==='Draft').length}</div><div className="stat-sub">Unsent</div></div>
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <h3 style={{ fontFamily:'var(--font-display)', fontSize:16, fontWeight:500, color:'var(--text-primary)' }}>SMS campaigns</h3>
        <button className="btn btn-primary" onClick={()=>setComposing(true)}>+ New SMS campaign</button>
      </div>

      {composing && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header"><span className="card-title">Compose SMS</span><button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>setComposing(false)}>✕</button></div>
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              <div><label style={{ fontSize:11,color:'var(--text-muted)',display:'block',marginBottom:5 }}>Campaign name *</label><input className="search-input" value={draft.name} onChange={e=>setDraft(d=>({...d,name:e.target.value}))} placeholder="e.g. Scout Activation SMS" /></div>
              <div><label style={{ fontSize:11,color:'var(--text-muted)',display:'block',marginBottom:5 }}>Send to</label><select className="search-input" value={draft.segment} onChange={e=>setDraft(d=>({...d,segment:e.target.value}))}>{SEGMENTS.map(s=><option key={s}>{s}</option>)}</select></div>
            </div>
            <div>
              <label style={{ fontSize:11,color:'var(--text-muted)',display:'block',marginBottom:5 }}>Message * — use {'{{first_name}}'} for personalisation</label>
              <textarea className="search-input" rows={4} value={draft.message} onChange={e=>setDraft(d=>({...d,message:e.target.value}))} placeholder="Hi {{first_name}}, ..." style={{ resize:'none', fontFamily:'var(--font-body)' }} />
              <div style={{ display:'flex', justifyContent:'space-between', marginTop:4 }}>
                <span style={{ fontSize:11, color:'var(--text-dim)' }}>{smsCount} SMS message{smsCount>1?'s':''}</span>
                <span style={{ fontSize:11, color:charCount>160?'#f5a623':'var(--text-dim)' }}>{charCount}/160 chars</span>
              </div>
            </div>
            {draft.message && (
              <div style={{ padding:'14px', background:'var(--bg-input)', borderRadius:10, border:'1px solid var(--border)' }}>
                <div style={{ fontSize:11, color:'var(--text-dim)', marginBottom:8, fontFamily:'var(--font-ui)' }}>PREVIEW</div>
                <div style={{ display:'inline-block', background:'#A7F432', color:'#0a1a0a', padding:'10px 14px', borderRadius:'16px 16px 16px 4px', fontSize:13, maxWidth:280, lineHeight:1.5 }}>
                  {draft.message.replace('{{first_name}}','James')}
                </div>
              </div>
            )}
            <div style={{ display:'flex', gap:16, alignItems:'center' }}>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:'var(--text-muted)' }}>
                <input type="checkbox" checked={draft.scheduleLater} onChange={e=>setDraft(d=>({...d,scheduleLater:e.target.checked}))} />
                Schedule for later
              </label>
              {draft.scheduleLater && <input type="datetime-local" className="search-input" style={{ maxWidth:220 }} value={draft.scheduleDate} onChange={e=>setDraft(d=>({...d,scheduleDate:e.target.value}))} />}
            </div>
            <div style={{ display:'flex', gap:8 }}><button className="btn btn-primary" onClick={send}>{draft.scheduleLater?'Schedule':'Send now'}</button><button className="btn btn-ghost" onClick={()=>setComposing(false)}>Cancel</button></div>
          </div>
        </div>
      )}

      <div className="card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Campaign</th><th>Segment</th><th>Message</th><th>Sent</th><th>Delivered</th><th>Delivery rate</th><th>Date</th><th>Status</th></tr></thead>
            <tbody>
              {campaigns.map(c=>(
                <tr key={c.id}>
                  <td style={{ fontWeight:500 }}>{c.name}</td>
                  <td style={{ color:'var(--text-muted)',fontSize:12 }}>{c.segment}</td>
                  <td style={{ color:'var(--text-muted)',fontSize:12,maxWidth:220 }}>{c.message?c.message.substring(0,60)+'...':'—'}</td>
                  <td>{c.sent.toLocaleString()}</td>
                  <td style={{ color:'var(--accent)',fontWeight:600 }}>{c.delivered.toLocaleString()}</td>
                  <td style={{ fontWeight:600 }}>{c.sent?Math.round((c.delivered/c.sent)*100)+'%':'—'}</td>
                  <td style={{ color:'var(--text-dim)',fontSize:12 }}>{c.date}</td>
                  <td><span className={statusBadge(c.status)}>{c.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
